import UpdateIcon from "@mui/icons-material/Update";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useCallback, useState } from "react";

import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";
import { useUpdate } from "~contexts/UpdateContext/UpdateContext.tsx";

import styles from "./UpdatePill.module.scss";

export function UpdatePill() {
  const { updateAvailable, updateNow } = useUpdate();
  const [disabled, setDisabled] = useState(false);
  const t = useTranslation();
  const theme = useTheme();
  const isUpMedium = useMediaQuery(theme.breakpoints.up("md"));

  const handleUpdate = useCallback(() => {
    setDisabled(true);
    updateNow();
  }, [updateNow]);

  if (!updateAvailable) return null;

  return (
    <button
      className={styles.pill}
      onClick={handleUpdate}
      disabled={disabled}
      type="button"
    >
      <UpdateIcon fontSize="small" />
      <span>{isUpMedium ? t.updateAvailable : t.updateAvailableMobile}</span>
    </button>
  );
}
